import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

@Injectable()
export class DataService_MultiStationCurrentVisitors {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	VisitorFacilitySelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorFacilitySelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	CurrentVisitorsSelectList(FacilityID) {
		var postResult$ = new Subject();
		var url = "MultiStation/CurrentVisitorsSelectList?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	GetPhotoByVisitorPass(VisitorPassID) {
		var postResult$ = new Subject();
		var url = "MultiStation/GetPhotoByVisitorPass?VisitorPassID=" + VisitorPassID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
